import React from 'react'
import { Box, Typography, Grid } from '@mui/material'
import { isDesktop } from 'react-device-detect'

export const AppTermsOfUse: React.FC = () => {
    const data = [
        {
            'type': 1,
            'content': 'Terms and Conditions for SHENMA Mobile',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'You may apply and register for SHENMA Mobile provided by Shenma Credit Sdn Bhd (“SHENMA Credit”) and by you using SHENMA Mobile, you agree to be bound by the following terms and conditions which is made available to you at the time of application and/or registration. These terms and conditions will be binding on you immediately upon your use of SHENMA Mobile.',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 1,
            'content': '1. Acceptance  of  SHENMA Mobile',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'If you have successfully registered for SHENMA Mobile, your use and continued use of SHENMA Mobile will signify your acknowledgement and agreement of these terms and conditions and any additions or amendments which may be made by SHENMA Credit from time to time. If you do not accept any or all of these terms and conditions, you may immediately discontinue all access of SHENMA Mobile. All questions which you may have concerning these terms and conditions shall be directed to SHENMA Mobile in the manner stated under Clause 13 herein.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 1,
            'content': '2. Software And Connectivity',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': '2.1 You are solely responsible:',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(a) to ensure that the computer terminal, mobile devices or other electronic devices and related software and hardware that are used to access SHENMA Mobile meet the required specifications and configurations; and',
            'paddingLeft': '55px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(b) to install, maintain and ensure the security of your computer terminal, mobile devices and/or other electronic devices, related hardware and software (including the internet browser software) and internet/data connection used to access SHENMA Mobile.',
            'paddingLeft': '55px',
            'underline': false
        },
        {
            'type': 2,
            'content': '2.2 SHENMA Credit shall not be responsible for any loss, damage or expense incurred by you or any third party due to your failure to adhere to any specifications or take or carry out the precautionary security measures in relation to your computer terminal, mobile devices and/or other electronic devices.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '2.3 Security Codes transmission',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(a) The delivery of any Security Codes (as defined below) to your mobile number or email address registered with SHENMA Mobile is entirely dependent on the availability and quality of service of the relevant service/network provider(s) and you hereby acknowledge and agree that SHENMA Credit does not have any control whatsoever in the event that:',
            'paddingLeft': '55px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(i) text message is delayed, not delivered or encountered any delivery issues due to mobile traffic congestion, network failure and/or interruptions that may be experienced by the relevant telecommunications network; and/or',
            'paddingLeft': '75px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(ii) email is delayed, not delivered or encountered any delivery issues by the relevant email provider(s), which shall include but not limited to diversion or filtering of such email as junk or spam email by the email providers.',
            'paddingLeft': '75px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(hereinafter referred to as “Network Failure”).',
            'paddingLeft': '95px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'As such, SHENMA Credit shall not be responsible or liable for any loss or expense incurred by you or any third party from any delay or failure in receiving any text message and/or email transmission from SHENMA Credit due to the Network Failure.',
            'paddingLeft': '95px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(b) You are responsible for providing SHENMA Credit with your valid and current contact details including mobile number and/or email address, and promptly notifying SHENMA Credit in the event of any changes. SHENMA Credit shall not be held responsible/liable in the event that SHENMA Credit is unable to contact you or unable to send/deliver text message and/or email to you due to inaccurate/invalid mobile number and/or email address provided by you or due to any reasons which are beyond the control of SHENMA Credit.',
            'paddingLeft': '55px',
            'underline': false
        },
        {
            'type': 1,
            'content': '3. Registration to SHENMA Mobile',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'First Time Registration',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(a) You must be above the age of eighteen (18) years upon application and/or registration of SHENMA Mobile. In the event that you are below the age of eighteen (18) years (“minor”), you must obtain the consent of your parent and/or legal guardian to use SHENMA Mobile.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(b) You are required to provide your name, NRIC, loan account number, mobile number, email address, residential address and any temporary code or ID issued by SHENMA Credit.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(c) Upon successful verification by SHENMA Credit, you shall follow the on-screen guided steps to create a username, password, security question and select a security picture.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(d) You will also need to confirm that you have read, understood and agreed to accept the terms and conditions.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(e) Once successful, you can login to SHENMA Mobile using your login credentials.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(f) Notwithstanding the above, your registration to access SHENMA Mobile is subject to the approval of SHENMA Credit.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(g) SHENMA Credit will request for your permission to access the necessary features, functions and data on your mobile device during the installation and operation of the SHENMA Mobile. This shall include gallery or media storage,  your mobile phone number, technical data such as device information and IP address, diagnostics and analytics data as well as the ability to provide notifications to you, in order to provide the full services and features of the SHENMA Mobile. The said information collected will not be shared with any third parties.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(h) By allowing us such access in Clause 3(g) above, you agree to also allow SHENMA Credit to collect and use the following information from your mobile device: ',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(a) Mobile phone number and technical data such as device information and IP address for fraud monitoring and prevention purposes.',
            'paddingLeft': '55px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(b) Diagnostics, technical and analytics data such as the SHENMA Mobile crash and usage information for user support and user experience improvement.',
            'paddingLeft': '55px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(i) You may at any time choose not to allow SHENMA Credit to have such access described in Clause 3(g) above. However, this will impact your experience of using, or prevent SHENMA Credit from providing you with, the Services on the SHENMA Mobile.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 1,
            'content': '4. SHENMA Mobile Services',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(a) By using SHENMA Mobile, you would be able to check the status of your loan applications, view the existing and New Services (as defined below), apply for loans, view the outstanding balances, make repayments, review payment history, receive notifications and alerts, update your profile and security settings, and access marketing and promotional information.  (“Services”).',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(b) Where SHENMA Credit offers new or additional products and services as part of the Services (“New Services”), SHENMA Credit may, by giving you prior written notice in accordance with Clause 11, make available such New Services to you and upon such additional terms and conditions (if any) as may be prescribed by SHENMA Credit. Your continued use of the Services through SHENMA Mobile will indicate that you agree and accept these terms and conditions as amended by such additional terms and conditions (if any) as may be prescribed by SHENMA Credit.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(c) SHENMA Mobile is intended to be available twenty-four (24) hours, seven (7) days a week. However, you acknowledge that at certain times some or all of the SHENMA Mobile Services may not be accessible due to system maintenance or other reasons or causes which are beyond the control of SHENMA Credit. You acknowledge that notwithstanding any provisions herein, SHENMA Credit does not warrant that SHENMA Mobile will be available at all times without interruption.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 1,
            'content': '5. Instructions',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(a) Any request, application, authorisation or instruction given by you to SHENMA Mobile,  pertaining to your account/loan account or any other Services (“Instructions”) initiated through the relevant security credentials used to identify you when you access and utilise SHENMA Mobile (“Security Codes”) shall be deemed Instruction and authorisations given by you to SHENMA Credit. SHENMA Credit is hereby authorised to act in accordance with such Instructions without inquiry on its part as to the identity of the person giving or appearing to give such Instructions or as to the authenticity of such Instructions. SHENMA Credit will not be responsible in ensuring the authenticity of the person giving the Instructions or for the misuse of unauthorised Instructions given.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(b) You may issue Instructions to cancel, revoke, reverse or amend your earlier Instructions and SHENMA Mobile may only comply with the subsequent Instructions provided that the earlier Instructions, have not been executed. It is your responsibility to ensure that the Instructions issued are complete, accurate and correct.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(c) SHENMA Mobile reserves the right not to comply with your Instructions if your Instructions are inconsistent with SHENMA Credit’s policy or rules and regulations in force for the time being. Notwithstanding the above, once the Instruction is being performed, such Instruction cannot be cancelled, withdrawn or changed and shall be binding on you.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 1,
            'content': '6. Security Responsibility',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'You agree that you shall be responsible to ensure and prevent unauthorised and fraudulent use of your SHENMA Mobile, using measures including but not limited to the following:',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(a) the Security Codes shall not be accessible to any other person, and shall not be disclosed or exposed to any person (including the employees of SHENMA Credit) under any circumstances or at any time;',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(b) the Security Codes should not be written down in any form or manner which may be deciphered by anyone;',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(c) your mobile device that you use to access SHENMA Mobile has installed anti-spyware, anti-virus and firewalls which are up-to-date;',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(d) you shall ensure that you access the correct internet browser address (“URL”) for SHENMA Mobile and that you have checked and confirmed that the correct security picture is displayed before entering your password when logging on to SHENMA Mobile;',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(e) it is your responsibility to update the SHENMA Mobile app as and when these updates are made available on the official supported app store; and',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(f) you shall change your password on a periodic basis.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 1,
            'content': '7. Liabilities',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': '7.1 By using SHENMA Mobile, you acknowledge and agree to accept the fundamental risks associated with carrying out transactions through the internet and mobile electronic devices; and that SHENMA Credit does not make any representations or warranties, whether expressed or implied with respect to SHENMA Mobile, including but not limited to merchantability and fitness for a particular purpose. No oral or written information or advice given by SHENMA Credit and their respective personnel, employees or agents shall create or enhance the scope of this warranty.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '7.2 You shall be fully responsible and liable, for the following:',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(a) any loss or damages suffered for all unauthorised transactions carried out through the use of the Security Codes until such time when SHENMA Credit has received notification of the same from you;',
            'paddingLeft': '55px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(b) any loss or damages suffered in the event you failed to unlink your own account from the SHENMA Mobile that was installed on your mobile device in accordance with the relevant steps set out by SHENMA Credit;',
            'paddingLeft': '55px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(c) any loss or damage suffered by SHENMA Credit as a result of your breach of or failure to comply with any of these terms and conditions or any relevant procedures set by SHENMA Credit;',
            'paddingLeft': '55px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(d) any loss or damage suffered due to your failure to provide accurate, complete and timely Instructions to SHENMA Credit; ',
            'paddingLeft': '55px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(e) any loss or damage suffered due to your negligent or fraudulent act;',
            'paddingLeft': '55px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(f) your failure to comply with these terms and conditions;',
            'paddingLeft': '55px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(g) any intrusion or attack by any person or party on any hardware, software or system used in relation to your access to SHENMA Mobile or on the internet, mobile and tablet device. The intrusion or attack includes but not limited to viruses, Trojan Horses, malware and or other harmful components or disabling devices that may suspend, disrupt or disable SHENMA Mobile or any part thereof; and',
            'paddingLeft': '55px',
            'underline': false
        },
        {
            'type': 2,
            'content': '(h) in the event SHENMA Credit is unable to perform any operations or to provide any of the Services due to any reason beyond SHENMA Credit’s control, which includes (but not limited to) fire, earthquake, landslides, flood, epidemic, pandemic, natural catastrophe or act of God, accident, riots, any failure, delay of disruption to telecommunications, electricity or services provided by the network service provider and order of any regulatory authority.',
            'paddingLeft': '55px',
            'underline': false
        },
        {
            'type': 2,
            'content': '7.3 To the maximum extent permitted by law, you acknowledge and agree that (i) you assume full responsibility for any loss that results from your use of SHENMA Mobile and under no circumstances shall SHENMA Credit be liable for any indirect, incidental, consequential, special, or punitive damages, including any loss of data, profits, revenues, business opportunities, even if they are based on negligence or SHENMA Credit has been advised of the possibility of those damages. SHENMA Credit’s total liability to you arising out of your use of SHENMA Mobile whether in contract, tort (including negligence), breach of statutory duty, or otherwise, will be no more than Ringgit Malaysia One Thousand (RM1,000.00).',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '7.4 Clause 7 shall survive even after the termination of your account/loan or Services with SHENMA Credit.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 1,
            'content': '8. Indemnity',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'You agree to hold harmless and keep SHENMA Credit fully and completely indemnified against any liabilities, claims, losses, damages and costs incurred (including legal fees) in connection with of arising out of your fault, act or omission in your use of SHENMA Mobile and the Services, the acceptance of any Instructions given by you or breach of any of these terms and conditions by you. This clause shall survive the termination of your use of and access to SHENMA Mobile.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 1,
            'content': '9. Termination by SHENMA Credit',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': '9.1 SHENMA Credit may suspend or terminate your access to SHENMA Mobile or any part of the Services if your access to SHENMA Mobile or usage of the Services is suspected to be inconsistent with any relevant laws, rules or regulations.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '9.2 SHENMA Credit will automatically terminate your right of access to SHENMA Mobile if your access to such accounts is suspended, restricted or prohibited by SHENMA Credit or any third party for any reason.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '9.3 You acknowledge and agree that where your access to SHENMA Mobile is terminated for any reason, SHENMA Credit shall not be liable for its failure to act upon and effect or perform or process any such Instructions received prior to such termination that remains unperformed or unprocessed at the point of such termination by SHENMA Credit or otherwise at the point of receipt of your notice to terminate.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 1,
            'content': '10. Severability and Waiver',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': '10.1 If any provision herein is or becomes illegal, invalid, prohibited or unenforceable under any applicable laws, the remaining provisions will remain in full force and effect and shall not be affected.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '10.2 No failure or delay by us in exercising our rights or remedies will operate as a waiver of any rights or remedies under these terms and conditions.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 1,
            'content': '11. Notices',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': '11.1 Any notices required to be given by SHENMA Credit to you under these terms and conditions may be given by (i) electronic mail to your last known SHENMA Mobile notification email address in SHENMA Credit’s records and such notices shall be deemed to be received after twenty-four (24) hours from transmission or (ii) by mobile text message to your last known mobile phone number in SHENMA Credit ‘s records, and shall be deemed to be received within twenty-four (24) hours from transmission or (iii) by ordinary post or registered post or courier sent to or left at your last address registered with SHENMA Credit and shall be deemed received by you within seven (7) business days from posting if sent by ordinary or registered post and within two (2) business days from sending if sent by courier.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': '11.2 You shall promptly inform SHENMA Credit of any changes to your personal details, telephone or mobile numbers or your electronic mail, correspondence and/or residential address in SHENMA Mobile.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 1,
            'content': '12. Consent to Process Personal Information',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'You hereby agree and consent to the collection and use of all personal data provided to SHENMA Credit by you, as well as personal data that arises as a result of the provision of the Services to you in connection with your loan application in accordance with the Privacy Policy of SHENMA Credit as may be amended from time to time.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 1,
            'content': '13. Queries',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'If you wish to make any queries or reach out to us in relation to SHENMA Mobiles or Services, you may contact Consumer Service Unit through email or call us at the following email address and contact number:-',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'Consumer Service Unit',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'Contact Number: +604 523 0033',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'Email: wecare@shenmacredit.com.my',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 1,
            'content': '14. Governing Law',
            'paddingLeft': '0px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'These terms and conditions will be governed solely by the laws of Malaysia without regard to the conflict of law principles. By accessing the SHENMA Mobile, you hereby consent to the exclusive jurisdiction of the Malaysian courts in Kuala Lumpur, Malaysia in all disputes arising out of relating to the use of the SHENMA Mobile.',
            'paddingLeft': '25px',
            'underline': false
        },
        {
            'type': 2,
            'content': 'The performance of SHENMA Credit’s obligations under these terms and conditions is subject always to all applicable laws and regulations. Nothing contained in these terms and conditions diminishes our rights to act so as to comply with and conform to any governmental requests or legal requirements relating to access to the SHENMA Mobile and use of the Services, or relating to any content provided to you or acquired by us for your use. We make no representation that the materials, information or Services provided on the SHENMA Mobile are appropriate or available for use in other jurisdictions other than Malaysia.',
            'paddingLeft': '25px',
            'underline': false
        },
    ]

    const titleItem = (index: number, content: string, paddingLeft: string, underline: boolean) => {
        return (
            <Grid key={index} item xs={12}>
                <Typography fontSize={isDesktop ? 22 : 16} fontWeight={600} color={'#333333'} style={{ textDecoration: underline ? 'underline' : 'none' }}>{content}</Typography>
            </Grid>
        )
    }

    const contentItem = (index: number, content: string, paddingLeft: string, underline: boolean) => {
        return (
            <Grid key={index} item xs={12} style={{ textDecoration: underline ? 'underline' : 'none' }}>
                <Typography fontSize={isDesktop ? 18 : 14} color={'#333333'} paddingLeft={paddingLeft}>{content}</Typography>
            </Grid>
        )
    }

    return (
        <Box sx={{
            width: '100%',
            paddingTop: isDesktop ? '60px' : '30px',
            paddingBottom: '60px',
            paddingLeft: isDesktop ? '100px' : '20px',
            paddingRight: isDesktop ? '100px' : '20px',
        }}>
            <Grid container rowSpacing={2}>
                {data.map((item, index) => (
                    data[index]['type'] === 1 ? titleItem(index, data[index]['content'], data[index]['paddingLeft'], data[index]['underline']) : contentItem(index, data[index]['content'], data[index]['paddingLeft'], data[index]['underline'])
                ))}
            </Grid>
        </Box>
    )
}
